
import { useRouter } from 'vue-router'
import { Dialog } from 'vant';
import { inject } from 'vue'
export default {
     components: {
      [Dialog.Component.name]: Dialog.Component,
  },
    props:{
        good_item:{  //商品信息
            type: Object,
            required: true,
        },
        is_click: {
            type: Boolean,
            default: () => {
                return false
            }
        }
    },
  setup(props:Object,{emit}:any){
      const router = useRouter()
      //获取货币
    const $store: any = inject('$store') 
    const currencyUnit:String = $store.getSymbol();
      //页面跳转
      const goodsDetails = (goods_id:string):void=>{
          if(props['is_click']) {
            router.push({
                name:'goods',
                params:{
                    id:goods_id
                }
            })
          }
      }      
 
      return {
          goodsDetails,
          currencyUnit,
      }
  }
}
